import { gql } from '@apollo/client';

const UPDATE_BEATS_AND_EVENTS_MUTATION = gql`
  mutation updateBeatsAndEvents($input: UpdateBeatsAndEventsInput!) {
    updateBeatsAndEvents(input: $input) {
      isSuccess
      message
      messageId
      command
    }
  }
`;

export default UPDATE_BEATS_AND_EVENTS_MUTATION;
